var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; // Save the previous value of the device variable.


var previousDevice = window.device;
var device = {};
var changeOrientationList = []; // Add device as a global object.

window.device = device; // The <html> element.

var documentElement = window.document.documentElement; // The client user agent string.
// Lowercase, so we can use the more efficient indexOf(), instead of Regex

var userAgent = window.navigator.userAgent.toLowerCase(); // Detectable television devices.

var television = ['googletv', 'viera', 'smarttv', 'internet.tv', 'netcast', 'nettv', 'appletv', 'boxee', 'kylo', 'roku', 'dlnadoc', 'pov_tv', 'hbbtv', 'ce-html']; // Main functions
// --------------

device.macos = function () {
  return find('mac');
};

device.ios = function () {
  return device.iphone() || device.ipod() || device.ipad();
};

device.iphone = function () {
  return !device.windows() && find('iphone');
};

device.ipod = function () {
  return find('ipod');
};

device.ipad = function () {
  var iPadOS13Up = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return find('ipad') || iPadOS13Up;
};

device.android = function () {
  return !device.windows() && find('android');
};

device.androidPhone = function () {
  return device.android() && find('mobile');
};

device.androidTablet = function () {
  return device.android() && !find('mobile');
};

device.blackberry = function () {
  return find('blackberry') || find('bb10') || find('rim');
};

device.blackberryPhone = function () {
  return device.blackberry() && !find('tablet');
};

device.blackberryTablet = function () {
  return device.blackberry() && find('tablet');
};

device.windows = function () {
  return find('windows');
};

device.windowsPhone = function () {
  return device.windows() && find('phone');
};

device.windowsTablet = function () {
  return device.windows() && find('touch') && !device.windowsPhone();
};

device.fxos = function () {
  return (find('(mobile') || find('(tablet')) && find(' rv:');
};

device.fxosPhone = function () {
  return device.fxos() && find('mobile');
};

device.fxosTablet = function () {
  return device.fxos() && find('tablet');
};

device.meego = function () {
  return find('meego');
};

device.cordova = function () {
  return window.cordova && location.protocol === 'file:';
};

device.nodeWebkit = function () {
  return _typeof(window.process) === 'object';
};

device.mobile = function () {
  return device.androidPhone() || device.iphone() || device.ipod() || device.windowsPhone() || device.blackberryPhone() || device.fxosPhone() || device.meego();
};

device.tablet = function () {
  return device.ipad() || device.androidTablet() || device.blackberryTablet() || device.windowsTablet() || device.fxosTablet();
};

device.desktop = function () {
  return !device.tablet() && !device.mobile();
};

device.television = function () {
  var i = 0;

  while (i < television.length) {
    if (find(television[i])) {
      return true;
    }

    i++;
  }

  return false;
};

device.portrait = function () {
  if (screen.orientation && Object.prototype.hasOwnProperty.call(window, 'onorientationchange')) {
    return includes(screen.orientation.type, 'portrait');
  }

  if (device.ios() && Object.prototype.hasOwnProperty.call(window, 'orientation')) {
    return Math.abs(window.orientation) !== 90;
  }

  return window.innerHeight / window.innerWidth > 1;
};

device.landscape = function () {
  if (screen.orientation && Object.prototype.hasOwnProperty.call(window, 'onorientationchange')) {
    return includes(screen.orientation.type, 'landscape');
  }

  if (device.ios() && Object.prototype.hasOwnProperty.call(window, 'orientation')) {
    return Math.abs(window.orientation) === 90;
  }

  return window.innerHeight / window.innerWidth < 1;
}; // Public Utility Functions
// ------------------------
// Run device.js in noConflict mode,
// returning the device variable to its previous owner.


device.noConflict = function () {
  window.device = previousDevice;
  return this;
}; // Private Utility Functions
// -------------------------
// Check if element exists


function includes(haystack, needle) {
  return haystack.indexOf(needle) !== -1;
} // Simple UA string search


function find(needle) {
  return includes(userAgent, needle);
} // Check if documentElement already has a given class.


function hasClass(className) {
  return documentElement.className.match(new RegExp(className, 'i'));
} // Add one or more CSS classes to the <html> element.


function addClass(className) {
  var currentClassNames = null;

  if (!hasClass(className)) {
    currentClassNames = documentElement.className.replace(/^\s+|\s+$/g, '');
    documentElement.className = currentClassNames + ' ' + className;
  }
} // Remove single CSS class from the <html> element.


function removeClass(className) {
  if (hasClass(className)) {
    documentElement.className = documentElement.className.replace(' ' + className, '');
  }
} // HTML Element Handling
// ---------------------
// Insert the appropriate CSS class based on the _user_agent.


if (device.ios()) {
  if (device.ipad()) {
    addClass('ios ipad tablet');
  } else if (device.iphone()) {
    addClass('ios iphone mobile');
  } else if (device.ipod()) {
    addClass('ios ipod mobile');
  }
} else if (device.macos()) {
  addClass('macos desktop');
} else if (device.android()) {
  if (device.androidTablet()) {
    addClass('android tablet');
  } else {
    addClass('android mobile');
  }
} else if (device.blackberry()) {
  if (device.blackberryTablet()) {
    addClass('blackberry tablet');
  } else {
    addClass('blackberry mobile');
  }
} else if (device.windows()) {
  if (device.windowsTablet()) {
    addClass('windows tablet');
  } else if (device.windowsPhone()) {
    addClass('windows mobile');
  } else {
    addClass('windows desktop');
  }
} else if (device.fxos()) {
  if (device.fxosTablet()) {
    addClass('fxos tablet');
  } else {
    addClass('fxos mobile');
  }
} else if (device.meego()) {
  addClass('meego mobile');
} else if (device.nodeWebkit()) {
  addClass('node-webkit');
} else if (device.television()) {
  addClass('television');
} else if (device.desktop()) {
  addClass('desktop');
}

if (device.cordova()) {
  addClass('cordova');
} // Orientation Handling
// --------------------
// Handle device orientation changes.


function handleOrientation() {
  if (device.landscape()) {
    removeClass('portrait');
    addClass('landscape');
    walkOnChangeOrientationList('landscape');
  } else {
    removeClass('landscape');
    addClass('portrait');
    walkOnChangeOrientationList('portrait');
  }

  setOrientationCache();
}

function walkOnChangeOrientationList(newOrientation) {
  for (var index in changeOrientationList) {
    changeOrientationList[index](newOrientation);
  }
}

device.onChangeOrientation = function (cb) {
  if (typeof cb == 'function') {
    changeOrientationList.push(cb);
  }
}; // Detect whether device supports orientationchange event,
// otherwise fall back to the resize event.


var orientationEvent = 'resize';

if (Object.prototype.hasOwnProperty.call(window, 'onorientationchange')) {
  orientationEvent = 'orientationchange';
} // Listen for changes in orientation.


if (window.addEventListener) {
  window.addEventListener(orientationEvent, handleOrientation, false);
} else if (window.attachEvent) {
  window.attachEvent(orientationEvent, handleOrientation);
} else {
  window[orientationEvent] = handleOrientation;
}

handleOrientation(); // Public functions to get the current value of type, os, or orientation
// ---------------------------------------------------------------------

function findMatch(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (device[arr[i]]()) {
      return arr[i];
    }
  }

  return 'unknown';
}

device.type = findMatch(['mobile', 'tablet', 'desktop']);
device.os = findMatch(['ios', 'iphone', 'ipad', 'ipod', 'android', 'blackberry', 'macos', 'windows', 'fxos', 'meego', 'television']);

function setOrientationCache() {
  device.orientation = findMatch(['portrait', 'landscape']);
}

setOrientationCache();

const and = (...predicates) => {
  return traffic => {
    return predicates.every(predicate => {
      return predicate(traffic);
    });
  };
};

const not = predicate => {
  return traffic => {
    return !predicate(traffic);
  };
};

const or = (...predicates) => {
  return traffic => {
    return predicates.some(predicate => {
      return predicate(traffic);
    });
  };
};

class URLParser {
  constructor(url) {
    const modifiedURL = url.toLowerCase().replace(/.*:\/\//, 'http://');
    const urlObject = new URL(modifiedURL);
    this.hostname = urlObject.hostname;
    this.pathname = urlObject.pathname.slice(1);
    this.searchParams = urlObject.searchParams;
  }

}

const pathnameIncludesAfterKey = key => {
  return traffic => {
    const urlObject = new URLParser(traffic.url);
    const pathnameParts = urlObject.pathname.split('/');
    const keyIndex = pathnameParts.indexOf(key);
    return keyIndex !== -1 && keyIndex !== pathnameParts.length - 1;
  };
};

const pathnameIncludesKey = pathParam => {
  return traffic => {
    const urlObject = new URLParser(traffic.url);
    const pathParts = urlObject.pathname.split('/');
    return pathParts.includes(pathParam);
  };
};

const referrerExists = () => {
  return traffic => {
    return traffic.referrer !== '';
  };
};

const SOCIAL_PLATFORMS = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  REDDIT: 'reddit'
};
const SEARCH_PLATFORMS = {
  GOOGLE: 'google',
  BING: 'bing',
  YAHOO: 'yahoo'
};
const PLATFORM_REGEXES = {
  [SOCIAL_PLATFORMS.FACEBOOK]: [/^facebook\./, /\.facebook\./],
  [SOCIAL_PLATFORMS.TWITTER]: [/^twitter\./, /\.twitter\./, /^t\.co/],
  [SOCIAL_PLATFORMS.INSTAGRAM]: [/^instagram\./, /\.instagram\./],
  [SOCIAL_PLATFORMS.REDDIT]: [/^reddit\./, /\.reddit\./],
  [SEARCH_PLATFORMS.GOOGLE]: [/^google\./, /\.google\./, /googleapi/, /googlequicksearchbox/, /amp-12up-com/, /amp\.12up\.com/],
  [SEARCH_PLATFORMS.BING]: [/^bing\./, /\.bing\./],
  [SEARCH_PLATFORMS.YAHOO]: [/^yahoo\./, /\.yahoo\./]
};
const TRAFFIC_SOURCES = {
  UNKNOWN: 'unknown',
  INFLUENCER: 'influencer',
  APP: 'app',
  EMBED_PARTNER: 'embed_partner',
  SYNDICATION: 'syndication',
  PAID: 'paid',
  SOCIAL: 'social',
  PARTNER: 'tr_partner',
  ORGANIC: 'organic',
  NAVIGATION: 'navigation',
  RSS: 'rss',
  SHARE: 'share',
  EMAIL: 'email',
  REFERRAL: 'referral',
  DIRECT: 'direct'
};
const TRAFFIC_INFO_KEY = 'trafficInfo';

const referrerIncludesPlatform = platform => {
  return traffic => {
    if (traffic.referrer === '') {
      return false;
    }

    const referrerObject = new URLParser(traffic.referrer);
    const {
      hostname
    } = referrerObject;
    return PLATFORM_REGEXES[platform].some(regex => regex.test(hostname));
  };
};

const referrerIsSameAsSite = () => {
  return traffic => {
    if (traffic.referrer === '') {
      return false;
    }

    const urlObject = new URLParser(traffic.url);
    const referrerObject = new URLParser(traffic.referrer);
    return urlObject.hostname === referrerObject.hostname;
  };
};

const searchParamEqualsValue = (searchParam, expectedValue) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value === expectedValue;
  };
};

const searchParamsIncludeKey = searchParam => {
  return traffic => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value !== null;
  };
};

const searchParamIncludesValue = (searchParam, expectedValue) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url);
    const value = urlObject.searchParams.get(searchParam);
    return value !== null && value.includes(expectedValue);
  };
};

const predicates = {
  and,
  not,
  or,
  pathnameIncludesAfterKey,
  pathnameIncludesKey,
  referrerExists,
  referrerIncludesPlatform,
  referrerIsSameAsSite,
  searchParamEqualsValue,
  searchParamsIncludeKey,
  searchParamIncludesValue
};

const searchParamValue = (traffic, key) => {
  const urlObject = new URLParser(traffic.url);
  return urlObject.searchParams.get(key);
};

const afterPathnameKey = (traffic, key) => {
  const urlObject = new URLParser(traffic.url);
  const pathnameParts = urlObject.pathname.split('/');
  const keyIndex = pathnameParts.indexOf(key);

  if (keyIndex === -1 || keyIndex === pathnameParts.length - 1) {
    return null;
  }

  return pathnameParts[keyIndex + 1];
};

const referrerHostname = traffic => {
  if (traffic.referrer === '') {
    return '';
  }

  const referrerObject = new URLParser(traffic.referrer);
  const {
    hostname
  } = referrerObject;
  const match = Object.entries(PLATFORM_REGEXES).find(([, regexes]) => regexes.some(regex => regex.test(hostname)));

  if (match) {
    const [platform] = match;
    return platform;
  }

  return hostname;
};

const selectors = {
  searchParamValue,
  afterPathnameKey,
  referrerHostname
};
const influencer = {
  rule: predicates.or(predicates.searchParamsIncludeKey('a_aid'), predicates.and(predicates.pathnameIncludesKey('partners'), predicates.pathnameIncludesAfterKey('partners'))),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.INFLUENCER;
    const trafficId = selectors.searchParamValue(traffic, 'a_aid') || selectors.afterPathnameKey(traffic, 'partners');
    return {
      trafficSource,
      trafficId
    };
  }
};
const app = {
  rule: predicates.searchParamEqualsValue('app', '1'),
  extractor: () => {
    return {
      trafficSource: TRAFFIC_SOURCES.APP,
      trafficId: null
    };
  }
};
const embedPartner = {
  rule: predicates.and(predicates.pathnameIncludesKey('embed'), predicates.searchParamsIncludeKey('partner')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.EMBED_PARTNER;
    const trafficId = selectors.searchParamValue(traffic, 'partner');
    return {
      trafficSource,
      trafficId
    };
  }
};
const syndication = {
  rule: predicates.and(predicates.pathnameIncludesKey('synd'), predicates.searchParamsIncludeKey('partner')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.SYNDICATION;
    const trafficId = selectors.searchParamValue(traffic, 'partner');
    return {
      trafficSource,
      trafficId
    };
  }
};
const paid = {
  rule: predicates.and(predicates.searchParamsIncludeKey('utm_source'), predicates.or(predicates.searchParamEqualsValue('utm_medium', 'fbads'), predicates.searchParamEqualsValue('utm_medium', 'cpc'), predicates.searchParamEqualsValue('utm_medium', 'fbads_dyn'), predicates.searchParamEqualsValue('utm_source', 'googlecpc'), predicates.searchParamEqualsValue('utm_source', 'cpc'))),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.PAID;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');
    return {
      trafficSource,
      trafficId
    };
  }
};
const social = {
  rule: predicates.or(...Object.values(SOCIAL_PLATFORMS).map(platform => predicates.referrerIncludesPlatform(platform)), predicates.searchParamEqualsValue('utm_medium', 'fan_page')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.SOCIAL;
    const trafficId = selectors.referrerHostname(traffic);
    return {
      trafficSource,
      trafficId
    };
  }
};
const trPartner = {
  rule: predicates.and(predicates.searchParamEqualsValue('utm_medium', 'tr_partner'), predicates.searchParamsIncludeKey('utm_source')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.PARTNER;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');
    return {
      trafficSource,
      trafficId
    };
  }
};
const organic = {
  rule: predicates.or(...Object.values(SEARCH_PLATFORMS).map(platform => predicates.referrerIncludesPlatform(platform))),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.ORGANIC;
    const trafficId = selectors.referrerHostname(traffic);
    return {
      trafficSource,
      trafficId
    };
  }
};
const navigation = {
  rule: predicates.referrerIsSameAsSite(),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.NAVIGATION;
    const trafficId = selectors.referrerHostname(traffic);
    return {
      trafficSource,
      trafficId
    };
  }
};
const rss = {
  rule: predicates.searchParamEqualsValue('utm_source', 'rss'),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.RSS;
    const trafficId = selectors.referrerHostname(traffic);
    return {
      trafficSource,
      trafficId
    };
  }
};
const share = {
  rule: predicates.and(predicates.searchParamIncludesValue('utm_medium', 'share'), predicates.searchParamsIncludeKey('utm_source')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.SHARE;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');
    return {
      trafficSource,
      trafficId
    };
  }
};
const email = {
  rule: predicates.and(predicates.searchParamIncludesValue('utm_medium', 'email'), predicates.searchParamsIncludeKey('utm_source')),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.EMAIL;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');
    return {
      trafficSource,
      trafficId
    };
  }
};
const referral = {
  rule: predicates.referrerExists(),
  extractor: traffic => {
    const trafficSource = TRAFFIC_SOURCES.REFERRAL;
    const trafficId = selectors.referrerHostname(traffic);
    return {
      trafficSource,
      trafficId
    };
  }
};
const direct = {
  rule: predicates.and(predicates.not(predicates.referrerExists()), predicates.not(predicates.or(predicates.searchParamsIncludeKey('utm_medium'), predicates.searchParamsIncludeKey('utm_source')))),
  extractor: () => {
    return {
      trafficSource: TRAFFIC_SOURCES.DIRECT,
      trafficId: null
    };
  }
}; // order of pipelines is important

const pipelines = [influencer, app, embedPartner, syndication, paid, social, trPartner, organic, navigation, rss, share, email, referral, direct];

const check = rule => {
  return traffic => {
    return rule(traffic);
  };
};

const checkAllRules = traffic => {
  const pipeline = pipelines.find(item => {
    return check(item.rule)(traffic);
  });

  if (pipeline) {
    return pipeline.extractor(traffic);
  }

  return {
    trafficSource: TRAFFIC_SOURCES.UNKNOWN,
    trafficId: null
  };
};

class LocalStorage {
  static getItem(keyName) {
    return JSON.parse(window.localStorage.getItem(keyName));
  }

  static setItem(keyName, keyValue) {
    return window.localStorage.setItem(keyName, JSON.stringify(keyValue));
  }

}

const analyze = () => {
  const traffic = {
    url: window.location.href,
    referrer: document.referrer
  };
  const {
    trafficSource: newSource,
    trafficId: newId
  } = checkAllRules(traffic);
  const sessionLength = 30;
  let trafficSource = newSource;
  let trafficId = newId;
  const trafficInfo = LocalStorage.getItem(TRAFFIC_INFO_KEY);

  if (trafficInfo !== null) {
    const {
      trafficSource: oldSource,
      trafficId: oldId,
      timestamp
    } = trafficInfo;
    const timestampValue = new Date(timestamp).getTime();
    const sessionPassed = new Date(timestampValue + sessionLength * 60000) < new Date();
    const isTrafficSourceNavigation = newSource === TRAFFIC_SOURCES.NAVIGATION;

    if (isTrafficSourceNavigation) {
      if (sessionPassed) {
        trafficSource = TRAFFIC_SOURCES.DIRECT;
        trafficId = null;
      } else {
        trafficSource = oldSource;
        trafficId = oldId;
      }
    }
  }

  LocalStorage.setItem(TRAFFIC_INFO_KEY, {
    trafficSource,
    trafficId,
    timestamp: new Date()
  });
};

const trafficSourceAnalysis = () => {
  analyze();
  const trafficInfo = LocalStorage.getItem(TRAFFIC_INFO_KEY);
  const {
    trafficSource,
    trafficId
  } = trafficInfo || {};
  const trafficSourceAndId = trafficId ? `${trafficSource}-${trafficId}` : trafficSource;
  return {
    trafficSource,
    trafficId,
    trafficSourceAndId
  };
};

const trafficSourceInfo = trafficSourceAnalysis();

function sendToDataLayer(event, data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...data,
    event
  });
}

function sendPageViewToGoogleAnalytics(params) {
  sendToDataLayer('GTM data ready to GA', params);
}
function sendEventToGoogleAnalytics(event_category, event_action, event_label, params) {
  const eventData = {
    GA_event_category: event_category,
    GA_event_action: event_action,
    GA_event_label: event_label
  };

  if (typeof params === 'object') {
    Object.keys(params).forEach(key => {
      eventData[`GA_${key}`] = params[key];
    });
  }

  sendToDataLayer('GTM event To GA', eventData);
}

const setEventEmitter = (eventName, eventHandler) => {
  if (window.__mmClientApiSubscriptions__ && window.__mmClientApiSubscriptions__.get(eventName)) {
    window.__mmClientApiSubscriptions__.get(eventName).forEach(params => eventHandler(params));
  }

  if (window.__mmClientApiSubscriptions__) {
    window.__mmClientApiSubscriptions__.set(eventName, {
      push: params => eventHandler(params)
    });
  } else {
    window.__mmClientApiSubscriptions__ = new Map();

    window.__mmClientApiSubscriptions__.set(eventName, {
      push: params => eventHandler(params)
    });
  }
};

function sendPageView(params) {
  sendPageViewToGoogleAnalytics(params);
}

function extractGAParams(params) {
  const {
    event_category,
    event_action,
    event_label,
    ...additionalParams
  } = params;
  sendEventToGoogleAnalytics(event_category, event_action, event_label, additionalParams);
}

function analyticsEventEmitter() {
  setEventEmitter('analytics', params => extractGAParams(params));
}
function initAnalytics(params) {
  sendPageView(params);
  analyticsEventEmitter();
}

function markPerformance(name) {
  if (typeof window !== 'undefined' && typeof window.performance !== 'undefined' && typeof window.performance.mark !== 'undefined') {
    window.performance.mark(name);
  }
}
function measurePerformance(name, start, end) {
  if (typeof window !== 'undefined' && typeof window.performance !== 'undefined' && typeof window.performance.measure !== 'undefined') {
    window.performance.measure(name, start, end);
  }
}

const googleTagServerName = 'googletag';
const getGoogleTag = () => {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  return window.googletag;
};
const getConstructedUnitPath = (adUnitPath, adsCategory) => {
  return adUnitPath.replace('{}', adsCategory);
};
const gptDefineSlots = (adSlotsConfigurationByPlatform, units, adsCategory) => {
  const googletag = getGoogleTag();
  Object.entries(adSlotsConfigurationByPlatform).forEach(([unitKey, unitConf]) => {
    const {
      adUnitPath,
      sizes
    } = unitConf;
    const finalAdUnitPath = getConstructedUnitPath(adUnitPath, adsCategory);
    googletag.cmd.push(() => {
      googletag.defineSlot(finalAdUnitPath, sizes, units[unitKey]).addService(googletag.pubads());
    });
  });
  googletag.cmd.push(() => {
    googletag.pubads().disableInitialLoad();
    googletag.enableServices();
  });
};
const gptDisplayAds = units => {
  const googletag = getGoogleTag();
  Object.values(units).forEach(unitId => {
    googletag.cmd.push(() => {
      googletag.display(unitId);
    });
  });
};
const gptSetTargeting = params => {
  const googletag = getGoogleTag();
  Object.entries(params).forEach(([key, value]) => {
    googletag.cmd.push(() => {
      googletag.pubads().setTargeting(key, value);
    });
  });
};
const gptRefreshCallback = headerBiddingCallback => {
  return () => {
    const googletag = getGoogleTag();
    googletag.cmd.push(() => {
      headerBiddingCallback();
      googletag.pubads().refresh();
    });
  };
};
const gptSetViewableEvents = () => {
  const googletag = getGoogleTag();
  const adSizes = {};
  let firstAdLoaded = false;
  googletag.cmd.push(() => {
    googletag.pubads().addEventListener('slotRenderEnded', event => {
      if (!event.isEmpty) {
        const path = event.slot.getAdUnitPath(); // @ts-ignore

        adSizes[path] = event.size.join(',');
      }
    });
    googletag.pubads().addEventListener('impressionViewable', event => {
      const {
        slot
      } = event;

      if (!event.isEmpty) {
        window.mmClientApi = window.mmClientApi || [];
        const {
          mmClientApi
        } = window;
        const res = slot.getResponseInformation();
        const path = slot.getAdUnitPath();

        if (!firstAdLoaded) {
          firstAdLoaded = true;
          markPerformance('ad-loaded');
          measurePerformance('time-to-first-ad', 'init-ads', 'ad-loaded');
        }

        mmClientApi.push('analytics', {
          event_category: 'Ads tracking',
          event_action: 'ad impression',
          event_label: path,
          event_size: adSizes[path],
          event_advertiserId: res.advertiserId,
          event_creativeId: res.creativeId,
          event_lineItemId: res.lineItemId,
          // @ts-ignore
          event_sourceAgnosticCreativeId: res.sourceAgnosticCreativeId,
          // @ts-ignore
          event_sourceAgnosticLineItemId: res.sourceAgnosticLineItemId,
          // @ts-ignore
          event_yieldGroupIds: res.yieldGroupIds,
          // @ts-ignore
          event_isBackfill: res.isBackfill
        });
      }
    });
  });
};

const getApsTagTimeoutInMilliseconds = () => 1000;
const apstagInit = (amazonPublisherId, adServerName, errorProvider) => {
  if (!window.apstag || !window.apstag.init) {
    errorProvider.reportException({
      name: 'apstag',
      message: 'window.apstag or window.apstag.init is not defined. Amazon Header Bidding script probably was not executed on time, therefore ads will not render'
    });
    return;
  }

  window.apstag.init({
    pubID: amazonPublisherId,
    adServer: adServerName,
    bidTimeout: getApsTagTimeoutInMilliseconds()
  });
};

const createSlots = (adSlotsConfigurationByPlatform, units) => {
  return Object.entries(adSlotsConfigurationByPlatform).reduce((acc, [unitKey, unitConf]) => {
    const {
      adUnitPath,
      sizes
    } = unitConf;
    return [...acc, {
      slotID: units[unitKey],
      slotName: adUnitPath,
      sizes
    }];
  }, []);
};

const apstagFetchBids = (adSlotsConfigurationByPlatform, units, adServerCallback, errorProvider) => {
  if (!window.apstag || !window.apstag.fetchBids) {
    errorProvider.reportException({
      name: 'apstag',
      message: 'window.apstag or window.apstag.fetchBids is not defined. Amazon Header Bidding script probably was not executed on time, therefore ads will not render'
    });
    return;
  }

  window.apstag.fetchBids({
    slots: createSlots(adSlotsConfigurationByPlatform, units)
  }, adServerCallback(() => window.apstag.setDisplayBids()));
};

const sendCustomParameters = params => {
  gptSetTargeting(params);
};

const defineAdSlots = (adSlotsConfigurationByPlatform, units, adsCategory) => {
  gptSetViewableEvents();
  gptDefineSlots(adSlotsConfigurationByPlatform, units, adsCategory);
};

const enableHeaderBidding = (adSlotsConfigurationByPlatform, units, headerBidderPublisherID, errorProvider) => {
  apstagInit(headerBidderPublisherID, googleTagServerName, errorProvider);
  apstagFetchBids(adSlotsConfigurationByPlatform, units, gptRefreshCallback, errorProvider);
};

const displayAdSlots = units => {
  gptDisplayAds(units);
};

const getAdSlotsConfigurationByPlatform = (platform, adSlotsConf) => platform === 'desktop' ? adSlotsConf.desktop : adSlotsConf.mobile;

const initAds = (adSlots, params, adsCategory, headerBidderPublisherID, errorProvider) => {
  defineAdSlots(getAdSlotsConfigurationByPlatform(params.platform, adSlots.conf), adSlots.units, adsCategory);
  sendCustomParameters(params);
  enableHeaderBidding(getAdSlotsConfigurationByPlatform(params.platform, adSlots.conf), adSlots.units, headerBidderPublisherID, errorProvider);
  displayAdSlots(adSlots.units);
};

const performanceTimingObjectToGeneralObject = performanceTimingObject => JSON.parse(JSON.stringify(performanceTimingObject));

const initRealUserMonitoring = (countryCode, templateName, monitoringEndpoint, errorProvider) => {
  window.addEventListener('unload', () => {
    try {
      const {
        timing
      } = window.performance;
      const {
        navigationStart
      } = timing;
      const navigationTiming = Object.keys(performanceTimingObjectToGeneralObject(timing)) // @ts-ignore
      .filter(key => key !== 'navigationStart' && timing[key] !== 0).reduce((acc, key) => ({ ...acc,
        // @ts-ignore
        [key]: timing[key] - navigationStart
      }), {});
      const customTiming = window.performance.getEntriesByType('paint').concat(window.performance.getEntriesByType('mark')).filter(entry => entry.startTime !== 0).reduce((acc, entry) => ({ ...acc,
        [entry.name]: entry.startTime + entry.duration
      }), {});
      const customDuration = window.performance.getEntriesByType('measure').filter(entry => entry.duration !== 0).reduce((acc, entry) => ({ ...acc,
        [entry.name]: entry.duration
      }), {});
      window.navigator.sendBeacon(monitoringEndpoint, JSON.stringify({
        countryCode,
        pageType: templateName,
        userAgent: window.navigator.userAgent,
        ...navigationTiming,
        ...customTiming,
        ...customDuration
      }));
    } catch (e) {
      errorProvider.reportException(e);
    }
  });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var base64 = createCommonjsModule(function (module, exports) {

(function (root) {
  // Detect free variables `exports`.
  var freeExports =  exports; // Detect free variable `module`.

  var freeModule =  module && module.exports == freeExports && module; // Detect free variable `global`, from Node.js or Browserified code, and use
  // it as `root`.

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;

  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
    root = freeGlobal;
  }
  /*--------------------------------------------------------------------------*/


  var InvalidCharacterError = function (message) {
    this.message = message;
  };

  InvalidCharacterError.prototype = new Error();
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  var error = function (message) {
    // Note: the error messages used throughout this file match those used by
    // the native `atob`/`btoa` implementation in Chromium.
    throw new InvalidCharacterError(message);
  };

  var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // http://whatwg.org/html/common-microsyntaxes.html#space-character

  var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g; // `decode` is designed to be fully compatible with `atob` as described in the
  // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
  // The optimized base64-decoding algorithm used is based on @atk’s excellent
  // implementation. https://gist.github.com/atk/1020396

  var decode = function (input) {
    input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
    var length = input.length;

    if (length % 4 == 0) {
      input = input.replace(/==?$/, '');
      length = input.length;
    }

    if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
    /[^+a-zA-Z0-9/]/.test(input)) {
      error('Invalid character: the string to be decoded is not correctly encoded.');
    }

    var bitCounter = 0;
    var bitStorage;
    var buffer;
    var output = '';
    var position = -1;

    while (++position < length) {
      buffer = TABLE.indexOf(input.charAt(position));
      bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer; // Unless this is the first of a group of 4 characters…

      if (bitCounter++ % 4) {
        // …convert the first 8 bits to a single ASCII character.
        output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
      }
    }

    return output;
  }; // `encode` is designed to be fully compatible with `btoa` as described in the
  // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa


  var encode = function (input) {
    input = String(input);

    if (/[^\0-\xFF]/.test(input)) {
      // Note: no need to special-case astral symbols here, as surrogates are
      // matched, and the input is supposed to only contain ASCII anyway.
      error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
    }

    var padding = input.length % 3;
    var output = '';
    var position = -1;
    var a;
    var b;
    var c;
    var buffer; // Make sure any padding is handled outside of the loop.

    var length = input.length - padding;

    while (++position < length) {
      // Read three bytes, i.e. 24 bits.
      a = input.charCodeAt(position) << 16;
      b = input.charCodeAt(++position) << 8;
      c = input.charCodeAt(++position);
      buffer = a + b + c; // Turn the 24 bits into four chunks of 6 bits each, and append the
      // matching character for each of them to the output.

      output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
    }

    if (padding == 2) {
      a = input.charCodeAt(position) << 8;
      b = input.charCodeAt(++position);
      buffer = a + b;
      output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
    } else if (padding == 1) {
      buffer = input.charCodeAt(position);
      output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
    }

    return output;
  };

  var base64 = {
    'encode': encode,
    'decode': decode,
    'version': '0.1.0'
  }; // Some AMD build optimizers, like r.js, check for specific condition patterns
  // like the following:

  if (freeExports && !freeExports.nodeType) {
    if (freeModule) {
      // in Node.js or RingoJS v0.8.0+
      freeModule.exports = base64;
    } else {
      // in Narwhal or RingoJS v0.7.0-
      for (var key in base64) {
        base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
      }
    }
  } else {
    // in Rhino or a web browser
    root.base64 = base64;
  }
})(commonjsGlobal);
});

/**
 * Number of bits for encoding the version integer
 * Expected to be the same across versions
 */

var versionNumBits = 6;
/**
 * Definition of the consent string encoded format
 *
 * From https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/Draft_for_Public_Comment_Transparency%20%26%20Consent%20Framework%20-%20cookie%20and%20vendor%20list%20format%20specification%20v1.0a.pdf
 */

var vendorVersionMap = {
  /**
   * Version 1
   */
  1: {
    version: 1,
    metadataFields: ['version', 'created', 'lastUpdated', 'cmpId', 'cmpVersion', 'consentScreen', 'vendorListVersion'],
    fields: [{
      name: 'version',
      type: 'int',
      numBits: 6
    }, {
      name: 'created',
      type: 'date',
      numBits: 36
    }, {
      name: 'lastUpdated',
      type: 'date',
      numBits: 36
    }, {
      name: 'cmpId',
      type: 'int',
      numBits: 12
    }, {
      name: 'cmpVersion',
      type: 'int',
      numBits: 12
    }, {
      name: 'consentScreen',
      type: 'int',
      numBits: 6
    }, {
      name: 'consentLanguage',
      type: 'language',
      numBits: 12
    }, {
      name: 'vendorListVersion',
      type: 'int',
      numBits: 12
    }, {
      name: 'purposeIdBitString',
      type: 'bits',
      numBits: 24
    }, {
      name: 'maxVendorId',
      type: 'int',
      numBits: 16
    }, {
      name: 'isRange',
      type: 'bool',
      numBits: 1
    }, {
      name: 'vendorIdBitString',
      type: 'bits',
      numBits: function numBits(decodedObject) {
        return decodedObject.maxVendorId;
      },
      validator: function validator(decodedObject) {
        return !decodedObject.isRange;
      }
    }, {
      name: 'defaultConsent',
      type: 'bool',
      numBits: 1,
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      }
    }, {
      name: 'numEntries',
      numBits: 12,
      type: 'int',
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      }
    }, {
      name: 'vendorRangeList',
      type: 'list',
      listCount: function listCount(decodedObject) {
        return decodedObject.numEntries;
      },
      validator: function validator(decodedObject) {
        return decodedObject.isRange;
      },
      fields: [{
        name: 'isRange',
        type: 'bool',
        numBits: 1
      }, {
        name: 'startVendorId',
        type: 'int',
        numBits: 16
      }, {
        name: 'endVendorId',
        type: 'int',
        numBits: 16,
        validator: function validator(decodedObject) {
          return decodedObject.isRange;
        }
      }]
    }]
  }
};
var definitions = {
  versionNumBits: versionNumBits,
  vendorVersionMap: vendorVersionMap
};

/* eslint no-use-before-define: off */



var versionNumBits$1 = definitions.versionNumBits,
    vendorVersionMap$1 = definitions.vendorVersionMap;

function repeat(count) {
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
  var padString = '';

  for (var i = 0; i < count; i += 1) {
    padString += string;
  }

  return padString;
}

function padLeft(string, padding) {
  return repeat(Math.max(0, padding)) + string;
}

function padRight(string, padding) {
  return string + repeat(Math.max(0, padding));
}

function encodeIntToBits(number, numBits) {
  var bitString = '';

  if (typeof number === 'number' && !isNaN(number)) {
    bitString = parseInt(number, 10).toString(2);
  } // Pad the string if not filling all bits


  if (numBits >= bitString.length) {
    bitString = padLeft(bitString, numBits - bitString.length);
  } // Truncate the string if longer than the number of bits


  if (bitString.length > numBits) {
    bitString = bitString.substring(0, numBits);
  }

  return bitString;
}

function encodeBoolToBits(value) {
  return encodeIntToBits(value === true ? 1 : 0, 1);
}

function encodeDateToBits(date, numBits) {
  if (date instanceof Date) {
    return encodeIntToBits(date.getTime() / 100, numBits);
  }

  return encodeIntToBits(date, numBits);
}

function encodeLetterToBits(letter, numBits) {
  return encodeIntToBits(letter.toUpperCase().charCodeAt(0) - 65, numBits);
}

function encodeLanguageToBits(language) {
  var numBits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return encodeLetterToBits(language.slice(0, 1), numBits / 2) + encodeLetterToBits(language.slice(1), numBits / 2);
}

function decodeBitsToInt(bitString, start, length) {
  return parseInt(bitString.substr(start, length), 2);
}

function decodeBitsToDate(bitString, start, length) {
  return new Date(decodeBitsToInt(bitString, start, length) * 100);
}

function decodeBitsToBool(bitString, start) {
  return parseInt(bitString.substr(start, 1), 2) === 1;
}

function decodeBitsToLetter(bitString) {
  var letterCode = decodeBitsToInt(bitString);
  return String.fromCharCode(letterCode + 65).toLowerCase();
}

function decodeBitsToLanguage(bitString, start, length) {
  var languageBitString = bitString.substr(start, length);
  return decodeBitsToLetter(languageBitString.slice(0, length / 2)) + decodeBitsToLetter(languageBitString.slice(length / 2));
}

function encodeField(_ref) {
  var input = _ref.input,
      field = _ref.field;
  var name = field.name,
      type = field.type,
      numBits = field.numBits,
      encoder = field.encoder,
      validator = field.validator;

  if (typeof validator === 'function') {
    if (!validator(input)) {
      return '';
    }
  }

  if (typeof encoder === 'function') {
    return encoder(input);
  }

  var bitCount = typeof numBits === 'function' ? numBits(input) : numBits;
  var inputValue = input[name];
  var fieldValue = inputValue === null || inputValue === undefined ? '' : inputValue;

  switch (type) {
    case 'int':
      return encodeIntToBits(fieldValue, bitCount);

    case 'bool':
      return encodeBoolToBits(fieldValue);

    case 'date':
      return encodeDateToBits(fieldValue, bitCount);

    case 'bits':
      return padRight(fieldValue, bitCount - fieldValue.length).substring(0, bitCount);

    case 'list':
      return fieldValue.reduce(function (acc, listValue) {
        return acc + encodeFields({
          input: listValue,
          fields: field.fields
        });
      }, '');

    case 'language':
      return encodeLanguageToBits(fieldValue, bitCount);

    default:
      throw new Error('ConsentString - Unknown field type ' + type + ' for encoding');
  }
}

function encodeFields(_ref2) {
  var input = _ref2.input,
      fields = _ref2.fields;
  return fields.reduce(function (acc, field) {
    acc += encodeField({
      input: input,
      field: field
    });
    return acc;
  }, '');
}

function decodeField(_ref3) {
  var input = _ref3.input,
      output = _ref3.output,
      startPosition = _ref3.startPosition,
      field = _ref3.field;
  var type = field.type,
      numBits = field.numBits,
      decoder = field.decoder,
      validator = field.validator,
      listCount = field.listCount;

  if (typeof validator === 'function') {
    if (!validator(output)) {
      // Not decoding this field so make sure we start parsing the next field at
      // the same point
      return {
        newPosition: startPosition
      };
    }
  }

  if (typeof decoder === 'function') {
    return decoder(input, output, startPosition);
  }

  var bitCount = typeof numBits === 'function' ? numBits(output) : numBits;

  switch (type) {
    case 'int':
      return {
        fieldValue: decodeBitsToInt(input, startPosition, bitCount)
      };

    case 'bool':
      return {
        fieldValue: decodeBitsToBool(input, startPosition)
      };

    case 'date':
      return {
        fieldValue: decodeBitsToDate(input, startPosition, bitCount)
      };

    case 'bits':
      return {
        fieldValue: input.substr(startPosition, bitCount)
      };

    case 'list':
      return decodeList(input, output, startPosition, field, listCount);

    case 'language':
      return {
        fieldValue: decodeBitsToLanguage(input, startPosition, bitCount)
      };

    default:
      throw new Error('ConsentString - Unknown field type ' + type + ' for decoding');
  }
}

function decodeList(input, output, startPosition, field, listCount) {
  var listEntryCount = 0;

  if (typeof listCount === 'function') {
    listEntryCount = listCount(output);
  } else if (typeof listCount === 'number') {
    listEntryCount = listCount;
  }

  var newPosition = startPosition;
  var fieldValue = [];

  for (var i = 0; i < listEntryCount; i += 1) {
    var decodedFields = decodeFields({
      input: input,
      fields: field.fields,
      startPosition: newPosition
    });
    newPosition = decodedFields.newPosition;
    fieldValue.push(decodedFields.decodedObject);
  }

  return {
    fieldValue: fieldValue,
    newPosition: newPosition
  };
}

function decodeFields(_ref4) {
  var input = _ref4.input,
      fields = _ref4.fields,
      _ref4$startPosition = _ref4.startPosition,
      startPosition = _ref4$startPosition === undefined ? 0 : _ref4$startPosition;
  var position = startPosition;
  var decodedObject = fields.reduce(function (acc, field) {
    var name = field.name,
        numBits = field.numBits;

    var _decodeField = decodeField({
      input: input,
      output: acc,
      startPosition: position,
      field: field
    }),
        fieldValue = _decodeField.fieldValue,
        newPosition = _decodeField.newPosition;

    if (fieldValue !== undefined) {
      acc[name] = fieldValue;
    }

    if (newPosition !== undefined) {
      position = newPosition;
    } else if (typeof numBits === 'number') {
      position += numBits;
    }

    return acc;
  }, {});
  return {
    decodedObject: decodedObject,
    newPosition: position
  };
}
/**
 * Encode the data properties to a bit string. Encoding will encode
 * either `selectedVendorIds` or the `vendorRangeList` depending on
 * the value of the `isRange` flag.
 */


function encodeDataToBits(data, definitionMap) {
  var version = data.version;

  if (typeof version !== 'number') {
    throw new Error('ConsentString - No version field to encode');
  } else if (!definitionMap[version]) {
    throw new Error('ConsentString - No definition for version ' + version);
  } else {
    var fields = definitionMap[version].fields;
    return encodeFields({
      input: data,
      fields: fields
    });
  }
}
/**
 * Take all fields required to encode the consent string and produce the URL safe Base64 encoded value
 */


function encodeToBase64(data) {
  var definitionMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vendorVersionMap$1;
  var binaryValue = encodeDataToBits(data, definitionMap);

  if (binaryValue) {
    // Pad length to multiple of 8
    var paddedBinaryValue = padRight(binaryValue, 7 - (binaryValue.length + 7) % 8); // Encode to bytes

    var bytes = '';

    for (var i = 0; i < paddedBinaryValue.length; i += 8) {
      bytes += String.fromCharCode(parseInt(paddedBinaryValue.substr(i, 8), 2));
    } // Make base64 string URL friendly


    return base64.encode(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  return null;
}

function decodeConsentStringBitValue(bitString) {
  var definitionMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vendorVersionMap$1;
  var version = decodeBitsToInt(bitString, 0, versionNumBits$1);

  if (typeof version !== 'number') {
    throw new Error('ConsentString - Unknown version number in the string to decode');
  } else if (!vendorVersionMap$1[version]) {
    throw new Error('ConsentString - Unsupported version ' + version + ' in the string to decode');
  }

  var fields = definitionMap[version].fields;

  var _decodeFields = decodeFields({
    input: bitString,
    fields: fields
  }),
      decodedObject = _decodeFields.decodedObject;

  return decodedObject;
}
/**
 * Decode the (URL safe Base64) value of a consent string into an object.
 */


function decodeFromBase64(consentString, definitionMap) {
  // Add padding
  var unsafe = consentString;

  while (unsafe.length % 4 !== 0) {
    unsafe += '=';
  } // Replace safe characters


  unsafe = unsafe.replace(/-/g, '+').replace(/_/g, '/');
  var bytes = base64.decode(unsafe);
  var inputBits = '';

  for (var i = 0; i < bytes.length; i += 1) {
    var bitString = bytes.charCodeAt(i).toString(2);
    inputBits += padLeft(bitString, 8 - bitString.length);
  }

  return decodeConsentStringBitValue(inputBits, definitionMap);
}

function decodeBitsToIds(bitString) {
  return bitString.split('').reduce(function (acc, bit, index) {
    if (bit === '1') {
      if (acc.indexOf(index + 1) === -1) {
        acc.push(index + 1);
      }
    }

    return acc;
  }, []);
}

var bits = {
  padRight: padRight,
  padLeft: padLeft,
  encodeField: encodeField,
  encodeDataToBits: encodeDataToBits,
  encodeIntToBits: encodeIntToBits,
  encodeBoolToBits: encodeBoolToBits,
  encodeDateToBits: encodeDateToBits,
  encodeLanguageToBits: encodeLanguageToBits,
  encodeLetterToBits: encodeLetterToBits,
  encodeToBase64: encodeToBase64,
  decodeBitsToIds: decodeBitsToIds,
  decodeBitsToInt: decodeBitsToInt,
  decodeBitsToDate: decodeBitsToDate,
  decodeBitsToBool: decodeBitsToBool,
  decodeBitsToLanguage: decodeBitsToLanguage,
  decodeBitsToLetter: decodeBitsToLetter,
  decodeFromBase64: decodeFromBase64
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var encodeToBase64$1 = bits.encodeToBase64,
    padRight$1 = bits.padRight;
/**
 * Encode a list of vendor IDs into bits
 *
 * @param {integer} maxVendorId Highest vendor ID in the vendor list
 * @param {integer[]} allowedVendorIds Vendors that the user has given consent to
 */


function encodeVendorIdsToBits(maxVendorId) {
  var allowedVendorIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var vendorString = '';

  for (var id = 1; id <= maxVendorId; id += 1) {
    vendorString += allowedVendorIds.indexOf(id) !== -1 ? '1' : '0';
  }

  return padRight$1(vendorString, Math.max(0, maxVendorId - vendorString.length));
}
/**
 * Encode a list of purpose IDs into bits
 *
 * @param {*} purposes List of purposes from the vendor list
 * @param {*} allowedPurposeIds List of purpose IDs that the user has given consent to
 */


function encodePurposeIdsToBits(purposes) {
  var allowedPurposeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  var maxPurposeId = 0;

  for (var i = 0; i < purposes.length; i += 1) {
    maxPurposeId = Math.max(maxPurposeId, purposes[i].id);
  }

  for (var _i = 0; _i < allowedPurposeIds.length; _i += 1) {
    maxPurposeId = Math.max(maxPurposeId, allowedPurposeIds[_i]);
  }

  var purposeString = '';

  for (var id = 1; id <= maxPurposeId; id += 1) {
    purposeString += allowedPurposeIds.indexOf(id) !== -1 ? '1' : '0';
  }

  return purposeString;
}
/**
 * Convert a list of vendor IDs to ranges
 *
 * @param {object[]} vendors List of vendors from the vendor list (important: this list must to be sorted by ID)
 * @param {integer[]} allowedVendorIds List of vendor IDs that the user has given consent to
 */


function convertVendorsToRanges(vendors, allowedVendorIds) {
  var range = [];
  var ranges = [];
  var idsInList = vendors.map(function (vendor) {
    return vendor.id;
  });

  for (var index = 0; index < vendors.length; index += 1) {
    var id = vendors[index].id;

    if (allowedVendorIds.indexOf(id) !== -1) {
      range.push(id);
    } // Do we need to close the current range?


    if ((allowedVendorIds.indexOf(id) === -1 // The vendor we are evaluating is not allowed
    || index === vendors.length - 1 // There is no more vendor to evaluate
    || idsInList.indexOf(id + 1) === -1 // There is no vendor after this one (ie there is a gap in the vendor IDs) ; we need to stop here to avoid including vendors that do not have consent
    ) && range.length) {
      var startVendorId = range.shift();
      var endVendorId = range.pop();
      range = [];
      ranges.push({
        isRange: typeof endVendorId === 'number',
        startVendorId: startVendorId,
        endVendorId: endVendorId
      });
    }
  }

  return ranges;
}
/**
 * Get maxVendorId from the list of vendors and return that id
 *
 * @param {object} vendors
 */


function getMaxVendorId(vendors) {
  // Find the max vendor ID from the vendor list
  var maxVendorId = 0;
  vendors.forEach(function (vendor) {
    if (vendor.id > maxVendorId) {
      maxVendorId = vendor.id;
    }
  });
  return maxVendorId;
}
/**
 * Encode consent data into a web-safe base64-encoded string
 *
 * @param {object} consentData Data to include in the string (see `utils/definitions.js` for the list of fields)
 */


function encodeConsentString(consentData) {
  var maxVendorId = consentData.maxVendorId;
  var _consentData$vendorLi = consentData.vendorList,
      vendorList = _consentData$vendorLi === undefined ? {} : _consentData$vendorLi,
      allowedPurposeIds = consentData.allowedPurposeIds,
      allowedVendorIds = consentData.allowedVendorIds;
  var _vendorList$vendors = vendorList.vendors,
      vendors = _vendorList$vendors === undefined ? [] : _vendorList$vendors,
      _vendorList$purposes = vendorList.purposes,
      purposes = _vendorList$purposes === undefined ? [] : _vendorList$purposes; // if no maxVendorId is in the ConsentData, get it

  if (!maxVendorId) {
    maxVendorId = getMaxVendorId(vendors);
  } // Encode the data with and without ranges and return the smallest encoded payload


  var noRangesData = encodeToBase64$1(_extends({}, consentData, {
    maxVendorId: maxVendorId,
    purposeIdBitString: encodePurposeIdsToBits(purposes, allowedPurposeIds),
    isRange: false,
    vendorIdBitString: encodeVendorIdsToBits(maxVendorId, allowedVendorIds)
  }));
  var vendorRangeList = convertVendorsToRanges(vendors, allowedVendorIds);
  var rangesData = encodeToBase64$1(_extends({}, consentData, {
    maxVendorId: maxVendorId,
    purposeIdBitString: encodePurposeIdsToBits(purposes, allowedPurposeIds),
    isRange: true,
    defaultConsent: false,
    numEntries: vendorRangeList.length,
    vendorRangeList: vendorRangeList
  }));
  return noRangesData.length < rangesData.length ? noRangesData : rangesData;
}

var encode = {
  convertVendorsToRanges: convertVendorsToRanges,
  encodeConsentString: encodeConsentString,
  getMaxVendorId: getMaxVendorId,
  encodeVendorIdsToBits: encodeVendorIdsToBits,
  encodePurposeIdsToBits: encodePurposeIdsToBits
};

var decodeBitsToIds$1 = bits.decodeBitsToIds,
    decodeFromBase64$1 = bits.decodeFromBase64;
/**
 * Decode consent data from a web-safe base64-encoded string
 *
 * @param {string} consentString
 */


function decodeConsentString(consentString) {
  var _decodeFromBase = decodeFromBase64$1(consentString),
      version = _decodeFromBase.version,
      cmpId = _decodeFromBase.cmpId,
      vendorListVersion = _decodeFromBase.vendorListVersion,
      purposeIdBitString = _decodeFromBase.purposeIdBitString,
      maxVendorId = _decodeFromBase.maxVendorId,
      created = _decodeFromBase.created,
      lastUpdated = _decodeFromBase.lastUpdated,
      isRange = _decodeFromBase.isRange,
      defaultConsent = _decodeFromBase.defaultConsent,
      vendorIdBitString = _decodeFromBase.vendorIdBitString,
      vendorRangeList = _decodeFromBase.vendorRangeList,
      cmpVersion = _decodeFromBase.cmpVersion,
      consentScreen = _decodeFromBase.consentScreen,
      consentLanguage = _decodeFromBase.consentLanguage;

  var consentStringData = {
    version: version,
    cmpId: cmpId,
    vendorListVersion: vendorListVersion,
    allowedPurposeIds: decodeBitsToIds$1(purposeIdBitString),
    maxVendorId: maxVendorId,
    created: created,
    lastUpdated: lastUpdated,
    cmpVersion: cmpVersion,
    consentScreen: consentScreen,
    consentLanguage: consentLanguage
  };

  if (isRange) {
    /* eslint no-shadow: off */
    var idMap = vendorRangeList.reduce(function (acc, _ref) {
      var isRange = _ref.isRange,
          startVendorId = _ref.startVendorId,
          endVendorId = _ref.endVendorId;
      var lastVendorId = isRange ? endVendorId : startVendorId;

      for (var i = startVendorId; i <= lastVendorId; i += 1) {
        acc[i] = true;
      }

      return acc;
    }, {});
    consentStringData.allowedVendorIds = [];

    for (var i = 1; i <= maxVendorId; i += 1) {
      if (defaultConsent && !idMap[i] || !defaultConsent && idMap[i]) {
        if (consentStringData.allowedVendorIds.indexOf(i) === -1) {
          consentStringData.allowedVendorIds.push(i);
        }
      }
    }
  } else {
    consentStringData.allowedVendorIds = decodeBitsToIds$1(vendorIdBitString);
  }

  return consentStringData;
}

var decode = {
  decodeConsentString: decodeConsentString
};

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var encodeConsentString$1 = encode.encodeConsentString,
    _getMaxVendorId = encode.getMaxVendorId,
    encodeVendorIdsToBits$1 = encode.encodeVendorIdsToBits,
    encodePurposeIdsToBits$1 = encode.encodePurposeIdsToBits;

var decodeConsentString$1 = decode.decodeConsentString;

var vendorVersionMap$2 = definitions.vendorVersionMap;
/**
 * Regular expression for validating
 */


var consentLanguageRegexp = /^[a-z]{2}$/;
var cachedString = void 0;

var ConsentString = function () {
  function ConsentString() {
    var baseString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ConsentString);

    this.maxVendorId = 0;
    this.created = new Date();
    this.lastUpdated = new Date();
    this.version = 1;
    this.vendorList = null;
    this.vendorListVersion = null;
    this.cmpId = null;
    this.cmpVersion = null;
    this.consentScreen = null;
    this.consentLanguage = null;
    this.allowedPurposeIds = [];
    this.allowedVendorIds = []; // Decode the base string

    if (baseString) {
      cachedString = baseString;
      Object.assign(this, decodeConsentString$1(baseString));
    }
  }

  _createClass(ConsentString, [{
    key: 'getConsentString',
    value: function getConsentString() {
      var updateDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var retr = void 0;
      /**
       * check for cached string that was passed in.  This avoids having to
       * decode the consent string and even to have a vendorlist
       */

      if (cachedString && !updateDate) {
        retr = cachedString;
      } else {
        if (!this.vendorList) {
          throw new Error('ConsentString - A vendor list is required to encode a consent string');
        }

        if (updateDate === true) {
          this.lastUpdated = new Date();
        }

        retr = encodeConsentString$1({
          version: this.getVersion(),
          vendorList: this.vendorList,
          allowedPurposeIds: this.allowedPurposeIds,
          allowedVendorIds: this.allowedVendorIds,
          created: this.created,
          lastUpdated: this.lastUpdated,
          cmpId: this.cmpId,
          cmpVersion: this.cmpVersion,
          consentScreen: this.consentScreen,
          consentLanguage: this.consentLanguage,
          vendorListVersion: this.vendorListVersion
        });
        cachedString = retr;
      }

      return retr;
    }
  }, {
    key: 'getLastUpdated',
    value: function getLastUpdated() {
      return this.lastUpdated;
    }
  }, {
    key: 'setLastUpdated',
    value: function setLastUpdated() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      cachedString = '';

      if (date) {
        this.lastUpdated = new Date(date);
      } else {
        this.lastUpdated = new Date();
      }
    }
  }, {
    key: 'getCreated',
    value: function getCreated() {
      return this.created;
    }
  }, {
    key: 'setCreated',
    value: function setCreated() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      cachedString = '';

      if (date) {
        this.created = new Date(date);
      } else {
        this.created = new Date();
      }
    }
  }, {
    key: 'getMaxVendorId',
    value: function getMaxVendorId() {
      if (!this.maxVendorId) {
        if (this.vendorList) {
          this.maxVendorId = _getMaxVendorId(this.vendorList.vendors);
        }
      }

      return this.maxVendorId;
    }
  }, {
    key: 'getParsedVendorConsents',
    value: function getParsedVendorConsents() {
      return encodeVendorIdsToBits$1(_getMaxVendorId(this.vendorList.vendors), this.allowedVendorIds);
    }
  }, {
    key: 'getParsedPurposeConsents',
    value: function getParsedPurposeConsents() {
      return encodePurposeIdsToBits$1(this.vendorList.purposes, this.allowedPurposeIds);
    }
  }, {
    key: 'getMetadataString',
    value: function getMetadataString() {
      return encodeConsentString$1({
        version: this.getVersion(),
        created: this.created,
        lastUpdated: this.lastUpdated,
        cmpId: this.cmpId,
        cmpVersion: this.cmpVersion,
        consentScreen: this.consentScreen,
        vendorListVersion: this.vendorListVersion
      });
    }
  }, {
    key: 'getVersion',
    value: function getVersion() {
      return this.version;
    }
  }, {
    key: 'getVendorListVersion',
    value: function getVendorListVersion() {
      return this.vendorListVersion;
    }
  }, {
    key: 'setGlobalVendorList',
    value: function setGlobalVendorList(vendorList) {
      if ((typeof vendorList === 'undefined' ? 'undefined' : _typeof$1(vendorList)) !== 'object') {
        throw new Error('ConsentString - You must provide an object when setting the global vendor list');
      }

      if (!vendorList.vendorListVersion || !Array.isArray(vendorList.purposes) || !Array.isArray(vendorList.vendors)) {
        // The provided vendor list does not look valid
        throw new Error('ConsentString - The provided vendor list does not respect the schema from the IAB EU’s GDPR Consent and Transparency Framework');
      } // does a vendorList already exist and is it a different version


      if (!this.vendorList || this.vendorListVersion !== vendorList.vendorListVersion) {
        cachedString = ''; // Cloning the GVL
        // It's important as we might transform it and don't want to modify objects that we do not own

        this.vendorList = {
          vendorListVersion: vendorList.vendorListVersion,
          lastUpdated: vendorList.lastUpdated,
          purposes: vendorList.purposes,
          features: vendorList.features,
          // Clone the list and sort the vendors by ID (it breaks our range generation algorithm if they are not sorted)
          vendors: vendorList.vendors.slice(0).sort(function (firstVendor, secondVendor) {
            return firstVendor.id < secondVendor.id ? -1 : 1;
          })
        };
        this.vendorListVersion = vendorList.vendorListVersion;
      }
    }
  }, {
    key: 'getGlobalVendorList',
    value: function getGlobalVendorList() {
      return this.vendorList;
    }
  }, {
    key: 'setCmpId',
    value: function setCmpId(id) {
      if (id !== this.cmpId) {
        cachedString = '';
        this.cmpId = id;
      }
    }
  }, {
    key: 'getCmpId',
    value: function getCmpId() {
      return this.cmpId;
    }
  }, {
    key: 'setCmpVersion',
    value: function setCmpVersion(version) {
      if (version !== this.cmpVersion) {
        cachedString = '';
        this.cmpVersion = version;
      }
    }
  }, {
    key: 'getCmpVersion',
    value: function getCmpVersion() {
      return this.cmpVersion;
    }
  }, {
    key: 'setConsentScreen',
    value: function setConsentScreen(screenId) {
      if (screenId !== this.consentScreen) {
        cachedString = '';
        this.consentScreen = screenId;
      }
    }
  }, {
    key: 'getConsentScreen',
    value: function getConsentScreen() {
      return this.consentScreen;
    }
  }, {
    key: 'setConsentLanguage',
    value: function setConsentLanguage(language) {
      if (consentLanguageRegexp.test(language) === false) {
        throw new Error('ConsentString - The consent language must be a two-letter ISO639-1 code (en, fr, de, etc.)');
      }

      if (language !== this.consentLanguage) {
        cachedString = '';
        this.consentLanguage = language;
      }
    }
  }, {
    key: 'getConsentLanguage',
    value: function getConsentLanguage() {
      return this.consentLanguage;
    }
  }, {
    key: 'setPurposesAllowed',
    value: function setPurposesAllowed(purposeIds) {
      cachedString = '';
      this.allowedPurposeIds = purposeIds;
    }
  }, {
    key: 'getPurposesAllowed',
    value: function getPurposesAllowed() {
      return this.allowedPurposeIds;
    }
  }, {
    key: 'setPurposeAllowed',
    value: function setPurposeAllowed(purposeId, value) {
      var purposeIndex = this.allowedPurposeIds.indexOf(purposeId);
      cachedString = '';

      if (value === true) {
        if (purposeIndex === -1) {
          this.allowedPurposeIds.push(purposeId);
        }
      } else if (value === false) {
        if (purposeIndex !== -1) {
          this.allowedPurposeIds.splice(purposeIndex, 1);
        }
      }
    }
  }, {
    key: 'isPurposeAllowed',
    value: function isPurposeAllowed(purposeId) {
      return this.allowedPurposeIds.indexOf(purposeId) !== -1;
    }
  }, {
    key: 'setVendorsAllowed',
    value: function setVendorsAllowed(vendorIds) {
      cachedString = '';
      this.allowedVendorIds = vendorIds;
    }
  }, {
    key: 'getVendorsAllowed',
    value: function getVendorsAllowed() {
      return this.allowedVendorIds;
    }
  }, {
    key: 'setVendorAllowed',
    value: function setVendorAllowed(vendorId, value) {
      var vendorIndex = this.allowedVendorIds.indexOf(vendorId);
      cachedString = '';

      if (value === true) {
        if (vendorIndex === -1) {
          this.allowedVendorIds.push(vendorId);
        }
      } else if (value === false) {
        if (vendorIndex !== -1) {
          this.allowedVendorIds.splice(vendorIndex, 1);
        }
      }
    }
  }, {
    key: 'isVendorAllowed',
    value: function isVendorAllowed(vendorId) {
      return this.allowedVendorIds.indexOf(vendorId) !== -1;
    }
  }], [{
    key: 'decodeMetadataString',
    value: function decodeMetadataString(encodedMetadata) {
      var decodedString = decodeConsentString$1(encodedMetadata);
      var metadata = {};
      vendorVersionMap$2[decodedString.version].metadataFields.forEach(function (field) {
        metadata[field] = decodedString[field];
      });
      return metadata;
    }
  }]);

  return ConsentString;
}();

var consentString = {
  ConsentString: ConsentString
};

var ConsentString$1 = consentString.ConsentString;

var decodeConsentString$2 = decode.decodeConsentString;

var encodeConsentString$2 = encode.encodeConsentString;

var dist = {
  ConsentString: ConsentString$1,
  decodeConsentString: decodeConsentString$2,
  encodeConsentString: encodeConsentString$2
};
var dist_1 = dist.ConsentString;

const removeNullParams = params => {
  return Object.keys(params).filter(key => params[key] !== null && typeof params[key] !== 'undefined').reduce((acc, key) => ({ ...acc,
    [key]: params[key]
  }), {});
};
function getCookieByName(name) {
  // @ts-ignore
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}
function setCookie(name, value) {
  document.cookie = `${name}=${value}`;
}

function monthShouldStartFromOne(date) {
  return date + 1;
}

function addLeadingZero(number) {
  return number < 10 ? `0${number}` : number;
}

function formatDate(date) {
  const month = addLeadingZero(monthShouldStartFromOne(date.getUTCMonth()));
  const day = addLeadingZero(date.getUTCDate());
  const hours = addLeadingZero(date.getUTCHours());
  const minutes = addLeadingZero(date.getUTCMinutes());
  return `${date.getUTCFullYear()}${month}${day}${hours}${minutes}`;
}
function readPublisherConsentCookie() {
  return getCookieByName('eupubconsent');
}
function readVendorsConsentCookie() {
  return getCookieByName('euconsent');
}
function getAnalyticsConsent(consentString) {
  const consentData = new dist_1(consentString);
  const measurementPurpose = 17; // @ts-ignore

  return !!consentData.getPurposesAllowed().find(purpose => purpose === measurementPurpose);
}
function getGdprApplies() {
  return getCookieByName('gdprApplies') || '1';
}
function updateGdprApplies() {
  // eslint-disable-next-line no-underscore-dangle
  if (typeof window.__cmp === 'undefined') {
    throw new Error('window doesn\'t have __cmp');
  } // eslint-disable-next-line no-underscore-dangle


  window.__cmp('getConsentData', null, (data, success) => {
    if (success) {
      setCookie('gdprApplies', data.gdprApplies ? 1 : 0);
    }
  });
}

const getURLObject = () => new URL(window.location.href);

const getURLQueryParam = key => {
  return getURLObject().searchParams.get(key);
};

const getURLPathnameValueAfterKey = key => {
  const pathnameParts = getURLObject().pathname.split('/');
  const indexOfKey = pathnameParts.indexOf(key);
  return indexOfKey !== -1 ? pathnameParts[indexOfKey + 1] : null;
};

const getAffiliateId = () => getURLQueryParam('a_aid') || getURLPathnameValueAfterKey('partners');

const getTest = () => getURLQueryParam('test');

const getPageURL = () => ({
  affiliateId: getAffiliateId(),
  test: getTest()
});

let userId;

const generateUUID = () => {
  let base = Date.now();

  if (typeof window !== 'undefined' && window.performance) {
    base += window.performance.now();
  }

  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, () => {
    /* eslint-disable-next-line no-bitwise */
    const r = (base + Math.random() * 10) % 10 | 0;
    base = Math.floor(base / 10);
    return r.toString(10);
  });
};

const getIdentifier = () => {
  try {
    if (window.localStorage) {
      userId = window.localStorage.getItem('userIdentifier');

      if (!userId) {
        userId = generateUUID();
        window.localStorage.setItem('userIdentifier', userId);
      }
    } // eslint-disable-next-line no-empty

  } catch (e) {}

  userId = userId || generateUUID();
  return userId;
};

const pageURL = getPageURL();
const monitoringEndpoint = 'https://rum.minutemediaservices.com/';
const createAdParameters = ({
  language,
  category,
  pageType,
  articleId,
  articleTemplate,
  channels,
  contentTags,
  mainMedia,
  commercialTags,
  dfpProperty
}) => removeNullParams({
  language,
  platform: device.type,
  category,
  contentTags,
  pageType,
  test: pageURL.test,
  affiliateId: pageURL.affiliateId,
  articleId,
  articleTemplate,
  distributionChannels: channels,
  mmUserIdentifier: getIdentifier(),
  trafficSource: trafficSourceInfo.trafficSource,
  trafficSourceAndId: trafficSourceInfo.trafficSourceAndId,
  mainMedia,
  commercialTags,
  dfpProperty
});
const createAnalyticsParametersWithAdParams = (adParameters, analyticsParams) => ({ ...adParameters,
  ...analyticsParams
});
const createAnalyticsParams = ({
  category,
  articleAuthor,
  articleTitle,
  articlePublicationTime,
  property,
  countryCode,
  articleContentCount,
  articleWordCount
}) => ({
  pageIdentifier: category,
  geoDetected: countryCode,
  GA_event_cookieConsent: readVendorsConsentCookie(),
  analyticsConsent: getAnalyticsConsent(readPublisherConsentCookie()),
  markupFormat: 'web',
  gdprApplies: getGdprApplies(),
  trafficReferrer: document.referrer,
  trafficId: trafficSourceInfo.trafficId,
  articleAuthor,
  articleTitle,
  articlePublicationTime: articlePublicationTime ? formatDate(new Date(articlePublicationTime)) : '',
  property,
  articleContentCount,
  articleWordCount
});
function init(params, errorProvider) {
  const {
    pageType,
    adSlots,
    headerBidderPublisherID,
    countryCode,
    category,
    dfpCategory
  } = params;
  const adParameters = createAdParameters(params);
  const adsCategory = dfpCategory || category;
  initRealUserMonitoring(countryCode, pageType, monitoringEndpoint, errorProvider);

  try {
    initAnalytics(createAnalyticsParametersWithAdParams(adParameters, createAnalyticsParams(params)));
    markPerformance('init-analytics');
  } catch (e) {
    errorProvider.reportException(e);
  }

  try {
    initAds(adSlots, adParameters, adsCategory, headerBidderPublisherID, errorProvider);
    markPerformance('init-ads');
  } catch (e) {
    errorProvider.reportException(e);
  }

  try {
    updateGdprApplies();
  } catch (e) {
    errorProvider.reportException(e);
  }
}

markPerformance('core-start');
const initCore = (params, errorReporter) => init(params, errorReporter);

export { createAdParameters, createAnalyticsParametersWithAdParams, createAnalyticsParams, init, initCore };
//# sourceMappingURL=index.bundle.esm.js.map
